
/**
 * Manages session-based download unlocking after form submission
 */
window.DownloadList = (function() {
  const STORAGE_KEY = 'downloadFormSubmitted';
  const DOWNLOAD_URL_KEY = 'pendingDownloadUrl';
  const SCROLL_TARGET_KEY = 'scrollToElement';

  const CONFIG = {
    TIMEOUTS: {
      DOWNLOAD_TRIGGER: 500,
      SCROLL_DELAY: 600,
      POST_RELOAD_ACTIONS: 50
    }
  };

  let isFormSuccessPage = false;

  function hasFormBeenSubmitted() {
    return sessionStorage.getItem(STORAGE_KEY) === 'true';
  }

  function setFormAsSubmitted() {
    sessionStorage.setItem(STORAGE_KEY, 'true');
  }

  function setPendingDownloadUrl(url) {
    sessionStorage.setItem(DOWNLOAD_URL_KEY, url);
  }

  function getPendingDownloadUrl() {
    return sessionStorage.getItem(DOWNLOAD_URL_KEY);
  }

  function clearPendingDownloadUrl() {
    sessionStorage.removeItem(DOWNLOAD_URL_KEY);
  }

  function setScrollTarget(elementId) {
    sessionStorage.setItem(SCROLL_TARGET_KEY, elementId);
  }

  function getScrollTarget() {
    return sessionStorage.getItem(SCROLL_TARGET_KEY);
  }

  function clearScrollTarget() {
    sessionStorage.removeItem(SCROLL_TARGET_KEY);
  }

  function scrollToCenter(target) {
    if (target) {
      target.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      });
    }
  }

  function unlockDownloads() {
    const gatedDownloads = document.querySelectorAll('[data-gated-download]');

    gatedDownloads.forEach(function(container) {
      const nextSibling = container.nextElementSibling;
      if (nextSibling && nextSibling.hasAttribute('data-download-link')) {
        nextSibling.style.display = 'flex';
        nextSibling.setAttribute('data-download-link', 'visible');
        container.style.display = 'none';
      } else {
        const internalLink = container.querySelector('[data-download-link]');
        if (internalLink) {
          internalLink.style.display = 'flex';
          internalLink.setAttribute('data-download-link', 'visible');

          const formContainers = container.querySelectorAll('[data-form-container]');
          const modalOpeners = container.querySelectorAll('[data-modal-opener]');

          formContainers.forEach(function(formContainer) {
            formContainer.style.display = 'none';
          });

          modalOpeners.forEach(function(opener) {
            opener.style.display = 'none';
          });
        }
      }
    });

    const allDownloadLinks = document.querySelectorAll('[data-download-link]');
    allDownloadLinks.forEach(function(link) {
      const prevSibling = link.previousElementSibling;
      const isStandalone = !prevSibling || !prevSibling.hasAttribute('data-gated-download');

      if (isStandalone) {
        link.style.display = 'flex';
        link.setAttribute('data-download-link', 'visible');

        //get first ".download-card" parent and hide the whole ".download-card__body"
        //so the unlocked link sits directly next to the thumbnail (SUS-528)
        const downloadCard = link.closest('.download-card');
        if (downloadCard) {
          const downloadCardBody = downloadCard.querySelector('.download-card__body');
          if (downloadCardBody) {
            downloadCardBody.style.display = 'none';
          }
        }
      }
    });
  }

  function triggerDownload(url) {
    const link = document.createElement('a');
    link.href = url;
    link.download = '';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  function checkIsFormSuccessPage() {
    const urlParams = new URLSearchParams(window.location.search);
    const hasFragment = window.location.hash && window.location.hash.includes('DownloadForm');
    return urlParams.get('contact_posted') === 'true' && hasFragment;
  }

  function handlePostReloadActions() {
    if (checkIsFormSuccessPage()) {
      isFormSuccessPage = true;

      const formId = getScrollTarget();
      if (formId) {
        const downloadIndex = formId.replace('DownloadForm-', '');
        // Compact/detailed view uses id "download-N", card view uses id "download-card-N"
        const originalContainer = document.getElementById('download-' + downloadIndex) ||
          document.getElementById('download-card-' + downloadIndex);
        let scrollTargetId = originalContainer ? originalContainer.id : 'download-' + downloadIndex;

        if (originalContainer && originalContainer.nextElementSibling &&
          originalContainer.nextElementSibling.hasAttribute('data-download-link')) {
          // Compact/detailed view: the unlocked link is the next sibling of the container
          const siblingLink = originalContainer.nextElementSibling;
          const linkId = 'download-link-' + downloadIndex;
          siblingLink.id = linkId;
          scrollTargetId = linkId;
        } else if (originalContainer) {
          // Card view: the unlocked link is a child of the card container
          const childLink = originalContainer.querySelector('[data-download-link]');
          if (childLink) {
            const linkId = 'download-link-' + downloadIndex;
            childLink.id = linkId;
            scrollTargetId = linkId;
          }
        }

        setScrollTarget(scrollTargetId);

        if (window.history && window.history.replaceState) {
          const cleanUrl = window.location.href.split('#')[0];
          window.history.replaceState({}, document.title, cleanUrl);
        }

        setFormAsSubmitted();
        unlockDownloads();

        handlePendingDownload();
        setTimeout(handlePostReloadScrolling, CONFIG.TIMEOUTS.SCROLL_DELAY);
        return;
      }
    }

    if (!window.articleDownloads) {
      handlePendingDownload();
      setTimeout(handlePostReloadScrolling, CONFIG.TIMEOUTS.SCROLL_DELAY);
    }
  }

  function handlePendingDownload() {
    if (window.downloadHandlerExecuted) {
      return;
    }

    const pendingUrl = getPendingDownloadUrl();
    if (pendingUrl) {
      window.downloadHandlerExecuted = true;
      setTimeout(function() {
        triggerDownload(pendingUrl);
        clearPendingDownloadUrl();
      }, CONFIG.TIMEOUTS.DOWNLOAD_TRIGGER);
    }
  }

  function handlePostReloadScrolling() {
    const scrollTargetId = getScrollTarget();
    if (scrollTargetId) {
      const targetElement = document.getElementById(scrollTargetId);
      if (targetElement) {
        if (targetElement.style.display === 'none') {
          targetElement.style.display = '';
        }

        try {
          targetElement.scrollIntoView({
            block: 'center',
            behavior: 'smooth',
          });
        } catch (scrollError) {
          try {
            targetElement.scrollIntoView(true);
          } catch (fallbackError) {
            // Silently fail if all scroll methods fail
          }
        }

        clearScrollTarget();
      } else {
        clearScrollTarget();
      }
    }
  }

  function handleFormSuccess() {
    if (hasFormBeenSubmitted()) {
      return;
    }

    if (isFormSuccessPage) {
      return;
    }

    setFormAsSubmitted();
    unlockDownloads();

    if (window.downloadHandlerExecuted) {
      return;
    }

    const pendingUrl = getPendingDownloadUrl();
    if (pendingUrl) {
      window.downloadHandlerExecuted = true;
      setTimeout(function() {
        triggerDownload(pendingUrl);
        clearPendingDownloadUrl();
      }, CONFIG.TIMEOUTS.DOWNLOAD_TRIGGER);
    }

    const scrollTargetId = getScrollTarget();
    if (scrollTargetId) {
      const targetElement = document.getElementById(scrollTargetId);
      if (targetElement) {
        setTimeout(function() {
          scrollToCenter(targetElement);
          clearScrollTarget();
        }, CONFIG.TIMEOUTS.SCROLL_DELAY);
      }
    }
  }

  function initializeDownloadState() {
    if (checkIsFormSuccessPage()) {
      isFormSuccessPage = true;
    }

    if (hasFormBeenSubmitted()) {
      unlockDownloads();
    }

    setTimeout(handlePostReloadActions, CONFIG.TIMEOUTS.POST_RELOAD_ACTIONS);
  }

  function findDownloadLinkForItem(downloadItem) {
    const nextSibling = downloadItem.nextElementSibling;
    if (nextSibling && nextSibling.hasAttribute('data-download-link')) {
      return nextSibling;
    }

    const downloadLink = downloadItem.querySelector('[data-download-link]');
    if (downloadLink) {
      return downloadLink;
    }

    return null;
  }

  function findDownloadItemForForm(form) {
    let downloadItem = form.closest('.download-list-item') || form.closest('.download-list-gated');

    if (downloadItem) {
      return downloadItem;
    }

    const modal = form.closest('modal-dialog');
    if (modal) {
      const modalId = modal.id;
      const modalMatch = modalId.match(/DownloadModal-(\d+)/);

      if (modalMatch) {
        const downloadIndex = modalMatch[1];
        // Compact/detailed view uses id "download-N", card view uses id "download-card-N"
        downloadItem = document.getElementById('download-' + downloadIndex) ||
          document.getElementById('download-card-' + downloadIndex);

        if (downloadItem) {
          return downloadItem;
        }
      }
    }

    return null;
  }

  function handleFormSubmit(e) {
    const form = e.target;
    const downloadItem = findDownloadItemForForm(form);

    if (downloadItem) {
      const downloadLink = findDownloadLinkForItem(downloadItem);
      if (downloadLink) {
        setPendingDownloadUrl(downloadLink.href);
      }

      const formDownloadId = form.getAttribute('data-download-id');
      if (formDownloadId) {
        setScrollTarget(formDownloadId);
      }
    }
  }

  function attachFormListeners() {
    const downloadForms = document.querySelectorAll('[data-download-form="true"]');

    downloadForms.forEach(function(form) {
      form.removeEventListener('submit', handleFormSubmit);
      form.addEventListener('submit', handleFormSubmit);
    });

    attachModalClickHandlers();
  }

  function attachModalClickHandlers() {
    const gatedElements = document.querySelectorAll('[data-gated-download]');

    gatedElements.forEach(function(gatedElement) {
      if (gatedElement.hasAttribute('data-click-handler-attached')) {
        return;
      }

      const modalOpener = gatedElement.querySelector('[data-modal-opener]');
      const downloadButton = gatedElement.querySelector('.download-icon-button');

      if (modalOpener && downloadButton) {
        gatedElement.addEventListener('click', function(event) {
          if (event.target.closest('.download-icon-button')) {
            return;
          }

          downloadButton.click();
        });

        gatedElement.style.cursor = 'pointer';

        // Mark as having click handler to avoid duplicate handlers
        gatedElement.setAttribute('data-click-handler-attached', 'true');
      }
    });
  }


  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        attachFormListeners();
        initializeDownloadState();
      });
    } else {
      attachFormListeners();
      initializeDownloadState();
    }
  }

  return {
    init: init,
    handleFormSuccess: handleFormSuccess,
    hasFormBeenSubmitted: hasFormBeenSubmitted,
    setFormAsSubmitted: setFormAsSubmitted,
    getPendingDownloadUrl: getPendingDownloadUrl,
    clearPendingDownloadUrl: clearPendingDownloadUrl,
    getScrollTarget: getScrollTarget,
    clearScrollTarget: clearScrollTarget,
    scrollToCenter: scrollToCenter
  };
})();

DownloadList.init();
